import React from 'react';
import { Modal, Upload, message, Icon } from 'antd';

const Dragger = Upload.Dragger;

const onChange = (info, onSuccess, id) => {
  const status = info.file.status;

  if (status !== 'uploading') {
    console.log(info.file, info.fileList);
  }

  if (status === 'done') {
    message.success(`${info.file.name} file uploaded successfully.`);
    onSuccess(id);
  } else if (status === 'error') {
    message.error(`${info.file.name} file upload failed.`);
  }
};

const PromoImageModal = props => {
  const { visible, onCancel, onOk, id, onSuccess, token } = props;

  return (
    <Modal title="Upload Image" visible={visible} onCancel={onCancel} onOk={onOk}>
      <Dragger
        name="files[]"
        multiple={false}
        action={`${process.env.REACT_APP_API_HOST}/cms/promos/${id}/images`}
        headers={{ Authorization: token }}
        onChange={info => onChange(info, onSuccess, id)}
      >
        <p className="ant-upload-drag-icon">
          <Icon type="inbox" />
        </p>
        <p className="ant-upload-text">Click or drag file to this area to upload</p>
      </Dragger>
    </Modal>
  );
};

export default PromoImageModal;



// WEBPACK FOOTER //
// ./src/components/Promo/PromoImageModal.js